'use strict';

import Async from 'async';
import _ from 'lodash';

export default class JobClassUploadController {
  /*@ngInject*/
  constructor($http, $q, $cookies, $timeout, $uibModalInstance) {
    this.$http = $http;
    this.$q = $q;
    this.$cookies = $cookies;
    this.$timeout = $timeout;
    this.$uibModalInstance = $uibModalInstance;

    this.fileInputField;
    this.isUploading = false;

    this.data = {
      selectedFiles: [],
      excelFileOnServer: '',
      excel: null,
      excelSelectedTabs: [],
      excelSelectedTabIdx: 0,
      excelSelectedTabData: null
    };
    this.excelColumns = [];
    this.fieldOptions = [
      {name: 'Name', value: 'name', alias: ['ClassName']},
      {name: 'Description', value: 'description', alias: ['ClassDesc']}
    ];
    this.form = {
      mappedFields: {}
    };
    this.invalidTabMsg = false;
    this.isImporting = false;
    this.importProgress = {
      current: 0,
      total: 0,
    };
  }

  sizeOf(obj) {
    return _.size(obj);
  }

  uploadFile() {
    let self = this;
    this.isUploading = true;
    this.$http({
        method: 'POST',
        url: '/api/types/jobClasses/upload?access_token=' + this.$cookies.get('token'),
        headers: {
          'Content-Type': undefined
        },
        data: {
          file: this.fileInputField
        },
        transformRequest: function(data, headersGetter) {
          let formData = new FormData();
          angular.forEach(data, function (value, key) {
            formData.append(key, value);
          });
          return formData;
        }
    })
    .then(function(response) {
      self.data.excelFileOnServer = response.data;
      self.parseFile(response.data);
      self.isUploading = false;
    }, function(error) {
      self.isUploading = false;
    });
  }

  parseFile(filename) {
    let self = this;
    this.$http.post('/api/types/jobClasses/parse',  {
      filename: filename
    }).then(function(response) {
      self.data.excel = response.data;
      if(_.size(self.data.excel.sheets)) {
        // get tabs
        angular.forEach(self.data.excel.sheets, function(tab) {
          self.data.excelSelectedTabs.push(tab.name);
        });
        // default to first tab
        self.selectTab(self.data.excelSelectedTabIdx);
      } else {
        self.data.resultMsg = 'Invalid excel.';
      }
    }, function(error) {

    });
  }

  colName(n) {
    var ordA = 'a'.charCodeAt(0);
    var ordZ = 'z'.charCodeAt(0);
    var len = ordZ - ordA + 1;
    var s = "";
    while(n >= 0) {
      s = String.fromCharCode(n % len + ordA) + s;
      n = Math.floor(n / len) - 1;
    }
    return s.toUpperCase();
  }

  createEmptyArray(nth) {
    let _array = [];
    let i = 0;
    for(i=0; i<nth; i++) {
      _array.push(this.colName(i));
    }
    this.excelColumns = _array;
  }

  guessColumnField() {
    let self = this;
    let match;
    let idx;

    angular.forEach(this.data.excelSelectedTabData.rows[1], function(col, k) {
      match = _.find(self.fieldOptions, function(o) {
        return o.name.toLowerCase() === col.v.toLowerCase();
      });
      if(match) {
        idx = _.findKey(self.excelColumns, function(o) {
          return o === k;
        });
        if(idx) {
          self.form.mappedFields[idx] = match.value;
        }
      } else {
        match = _.find(self.fieldOptions, function(o) {
          if(o.alias && o.alias.length) {
            return o.alias.indexOf(col.v) !== -1;
          }
          return false;
        });
        if(match) {
          idx = _.findKey(self.excelColumns, function(o) {
            return o === k;
          });
          if(idx) {
            self.form.mappedFields[idx] = match.value;
          }
        }
      }
    });
  }

  selectTab(idx) {
    let self = this;
    this.data.excelSelectedTabData = null;
    this.invalidTabMsg = false;
    this.$timeout(function() {
      let i = 0;
      let o;
      for(o in self.data.excel.sheets) {
        if(i === idx) {
          self.data.excelSelectedTabData = self.data.excel.sheets[o];
          self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
          break;
        } else {
          i++;
        }
      }
      self.data.excelSelectedTabIdx = idx;
      // if(_.size(self.data.excelSelectedTabData.rows[1]) !== self.fieldOptions.length) {
      //   self.invalidTabMsg = true;
      // }
    });
  }

  rendered() {
    this.guessColumnField();
  }

  createSeriesOfRequest(current, item, payload) {
    let self = this;
    return function(callback) {
      self.importProgress.current = current;
      self.$http.post('/api/types/jobClasses', payload)
        .then(function(response) {
          item.success = true;
          callback(null);
        }, function(err) {
          item.failed = true;
          callback(null);
        });
    };
  }

  processData(data) {
    let self = this;
    let deferred = this.$q.defer();
    let series = [];
    let payload = {};
    let excelCol;
    let excelColValue;
    angular.forEach(this.data.excelSelectedTabData.rows, function(item, rowNum) {
      if(rowNum !== '1') { // skip header
        payload = {};
        angular.forEach(self.form.mappedFields, function(field, idx) {
          excelCol = self.excelColumns[idx];
          excelColValue = item[excelCol].v;
          payload[field] = excelColValue;
        });
        //console.log(payload);
        series.push(self.createSeriesOfRequest(rowNum-1, item, payload));
      } // skip header
    });

    //console.log(series);
    this.importProgress.total = series.length;
    if(series.length) {
      Async.series(series, function(err, results) {
        deferred.resolve();
      });
    }
    return deferred.promise;
  }

  submitForm(form) {
    if(form.$valid) {
      if(this.data.excel) {
        let self = this;
        this.isImporting = true;
        //this.processData().then(function() {
          //self.$timeout(function() {
            //self.$uibModalInstance.close();
          //}, 5000);
        //});
        this.$http.post('/api/types/jobClasses/import',  {
          filename: self.data.excelFileOnServer,
          tabIdx: self.data.excelSelectedTabIdx,
          mappedFields: this.form.mappedFields,
          excelColumns: self.excelColumns
        }).then(function(response) {
          self.$timeout(function() {
            self.$uibModalInstance.close();
          }, 5000);
        }, function(error) {

        });
      }
    }
  };

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/jobClass.upload.controller.js